import Icon from "@hudson/ui/components/Icon";
import useConfig from "@lib/use_config";

export default function TypeIcon({
  className,
  color,
  type,
  typeKey,
}: {
  className?: string;
  color?: string;
  type?: string;
  typeKey?: string;
}): JSX.Element | null {
  const { data, loading, error } = useConfig(["locationTypeOptions { type image }"]);

  let icon = "locationMarker";
  if (type) {
    let displayType = type;
    // overrides?
    if (data?.config.locationTypeOptions) {
      const match = data.config.locationTypeOptions.find((opt) => opt.type === typeKey);
      if (match && match.image) displayType = match.image;
    }

    icon =
      {
        airport: "airport",
        attraction: "attraction",
        cruise: "cruise",
        food: "food",
        generic: "locationMarker",
        health: "health",
        hotel: "hotel",
        house: "house",
        locality: "globe",
        nature: "nature",
        road: "road",
        school: "school",
        store: "store",
        train: "train",
      }[displayType] || "locationMarker";
  }

  return loading ? null : <Icon className={className} color={color} type={icon} />;
}
